import { useEffect, useRef, useState } from 'react';
import {Link, useNavigate} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {logoutUsers} from '../store/UserSlice';
import {toast} from "react-toastify"; // Adjust the path based on your actual project structure



const DropdownUser = ({isDisabled = false}:{isDisabled?:boolean}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem('loginData') as string)?.user
  const ProfileDetails = JSON.parse(localStorage.getItem('profile') as string)
  const trigger = useRef<any>(null);
  const dropdown = useRef<any>(null);

  const handleLogout = () => {
    // Perform any additional cleanup or API calls if needed
    // ...

    // Dispatch the logout action
    dispatch(logoutUsers()).then(()=> {
      toast.success("Logged out Successfully.");
      const isAdmin = userDetails?.isAdmin;
      if(isAdmin == true) {
        navigate('/admin');
      }else{
        navigate('/');
      }      
      
    });
  };


  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }: MouseEvent) => {
      if (!dropdown.current) return;
      if (
        !dropdownOpen ||
        dropdown.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setDropdownOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }: KeyboardEvent) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  return (
    <div className="relative">
      <Link
        ref={trigger}
        onClick={() =>  isDisabled ?  null :setDropdownOpen(!dropdownOpen) }
        className="flex items-center gap-4"
        to="#"
      >
        <span className="text-right lg:block">
          <span className="block text-lg leading-5	 font-semibold text-[#000024] ">
            {ProfileDetails?.fullName ? ProfileDetails?.fullName : userDetails?.fullName}
          </span>
          
        </span>

        <span className="hidden md:block h-12 w-12 rounded-full">
        {userDetails?.icon ? ( <img src={ProfileDetails?.icon ? ProfileDetails?.icon : userDetails?.icon} alt="User" /> ):( <img src='./images/user/default-avatar.jpg' alt="User" /> )} 
        </span> 
        <svg
          className={` fill-current sm:block ${
            dropdownOpen ? 'rotate-180' : ''
          }`}
          width="12"
          height="8"
          viewBox="0 0 12 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.410765 0.910734C0.736202 0.585297 1.26384 0.585297 1.58928 0.910734L6.00002 5.32148L10.4108 0.910734C10.7362 0.585297 11.2638 0.585297 11.5893 0.910734C11.9147 1.23617 11.9147 1.76381 11.5893 2.08924L6.58928 7.08924C6.26384 7.41468 5.7362 7.41468 5.41077 7.08924L0.410765 2.08924C0.0853277 1.76381 0.0853277 1.23617 0.410765 0.910734Z"
            fill=""
          />
        </svg>
      </Link>

      {/* <!-- Dropdown Start --> */}
      <div
        ref={dropdown}
        onFocus={() => setDropdownOpen(true)}
        onBlur={() => setDropdownOpen(false)}
        className={`absolute -left-10 md:right-0 mt-5 flex w-50 flex-col rounded-sm   bg-[#252525ab] shadow-default  ${
          dropdownOpen === true ? 'block' : 'hidden'
        }`}
      >
        <a href='profile' className="flex items-center text-white gap-6.5 pt-4 pb-2 px-6 text-sm min-w-[12rem] duration-300 ease-in-out hover:text-primary hover:bg-gray-800 font-semibold lg:text-base"><svg className='inline pr-1' width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="8.57897" cy="5.77803" r="4.77803" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.00002 17.2013C0.998732 16.8654 1.07385 16.5336 1.2197 16.2311C1.67736 15.3157 2.96798 14.8306 4.03892 14.6109C4.81128 14.4461 5.59431 14.336 6.38217 14.2814C7.84084 14.1533 9.30793 14.1533 10.7666 14.2814C11.5544 14.3366 12.3374 14.4467 13.1099 14.6109C14.1808 14.8306 15.4714 15.27 15.9291 16.2311C16.2224 16.8479 16.2224 17.5639 15.9291 18.1807C15.4714 19.1418 14.1808 19.5812 13.1099 19.7917C12.3384 19.9633 11.5551 20.0766 10.7666 20.1304C9.57937 20.231 8.38659 20.2494 7.19681 20.1853C6.92221 20.1853 6.65677 20.1853 6.38217 20.1304C5.59663 20.0772 4.81632 19.964 4.04807 19.7917C2.96798 19.5812 1.68652 19.1418 1.2197 18.1807C1.0746 17.8746 0.999552 17.54 1.00002 17.2013Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
 My Account</a>
      
        <button className="flex items-center gap-6.5 pt-2 pb-4 px-6 text-sm  duration-300 text-white ease-in-out hover:text-primary font-semibold hover:bg-gray-800 lg:text-base" onClick={handleLogout}>
          <svg
            className="fill-current pr-1"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              d="M15.5375 0.618744H11.6531C10.7594 0.618744 10.0031 1.37499 10.0031 2.26874V4.64062C10.0031 5.05312 10.3469 5.39687 10.7594 5.39687C11.1719 5.39687 11.55 5.05312 11.55 4.64062V2.23437C11.55 2.16562 11.5844 2.13124 11.6531 2.13124H15.5375C16.3625 2.13124 17.0156 2.78437 17.0156 3.60937V18.3562C17.0156 19.1812 16.3625 19.8344 15.5375 19.8344H11.6531C11.5844 19.8344 11.55 19.8 11.55 19.7312V17.3594C11.55 16.9469 11.2062 16.6031 10.7594 16.6031C10.3125 16.6031 10.0031 16.9469 10.0031 17.3594V19.7312C10.0031 20.625 10.7594 21.3812 11.6531 21.3812H15.5375C17.2219 21.3812 18.5625 20.0062 18.5625 18.3562V3.64374C18.5625 1.95937 17.1875 0.618744 15.5375 0.618744Z"
              fill="white"
              stroke='white'
            />
            <path
              d="M6.05001 11.7563H12.2031C12.6156 11.7563 12.9594 11.4125 12.9594 11C12.9594 10.5875 12.6156 10.2438 12.2031 10.2438H6.08439L8.21564 8.07813C8.52501 7.76875 8.52501 7.2875 8.21564 6.97812C7.90626 6.66875 7.42501 6.66875 7.11564 6.97812L3.67814 10.4844C3.36876 10.7938 3.36876 11.275 3.67814 11.5844L7.11564 15.0906C7.25314 15.2281 7.45939 15.3312 7.66564 15.3312C7.87189 15.3312 8.04376 15.2625 8.21564 15.125C8.52501 14.8156 8.52501 14.3344 8.21564 14.025L6.05001 11.7563Z"
              fill="white"
              stroke='white'
            />
          </svg>
          Log Out
        </button>
      </div>
      {/* <!-- Dropdown End --> */}
    </div>
  );
};

export default DropdownUser;
